var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconEvaluators = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#CCC",
  strokeMiterlimit: 10,
  d: "M47 24c0 4.552-1.357 9.006-3.878 12.783a22.95 22.95 0 0 1-10.324 8.474 23.1 23.1 0 0 1-13.282 1.307c-4.46-.871-8.58-3.099-11.778-6.294-3.2-3.196-5.43-7.312-6.302-11.767S1 19.4 2.745 15.236a22.94 22.94 0 0 1 8.483-10.314C14.96 2.356 19.419 1 23.976 1s11.972 2.421 16.286 6.73A23 23 0 0 1 47 24Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeMiterlimit: 10,
  d: "M15.057 35.524h-.97V12.137h.97M17.965 19.642h12.506M17.965 21.773h12.506"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#772432",
  strokeMiterlimit: 10,
  d: "M18.16 17.705h12.117V14.8H18.16z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeMiterlimit: 10,
  d: "M17.965 25.259h11.44M17.965 27.39h8.968M17.965 30.876h6.69M17.965 33.006h5.332"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m29.792 27.535-6.495 7.796 1.503 1.258 6.495-7.795"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeMiterlimit: 10,
  d: "m36.675 22.45 1.212 1.017-5.38 6.489-.582-.484 4.363-5.23-.63-.533"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeLinejoin: "round",
  d: "m24.8 36.59-2.52 1.5 1.017-2.76"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#333",
  strokeMiterlimit: 10,
  d: "m29.793 27.486 1.648 1.356 5.72-6.876-1.649-1.356z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeMiterlimit: 10,
  d: "m29.792 27.535-6.495 7.796 1.503 1.258 6.495-7.795"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M15.348 34.846V12.815h17.11v8.716l.534-.63v-8.764H14.815v23.387h5.67l.582-.678zM32.458 34.846h-1.987l-.582.678h3.103V31.7l-.534.678z"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "m28.629 34.846-.582.678h1.842l.582-.678z"
})));
export { SvgIconEvaluators as ReactComponent };
export default __webpack_public_path__ + "2ad93e767003860f31ef5f7392c55f5a.svg";